import axios, { AxiosError } from "axios";
import { dangerAlert } from "reducers/alert.slice";
import { history } from "helpers/history";
import { getAccessToken } from "services/user.service";
import { logout } from "services/auth.service";
import SearchTransactionDto from "models/SearchTransactionDto";


export const processAxiosError = (error: AxiosError, dispatch: any) => {

    const errorMessage = error.message;

    if (history.navigate != null)
        switch (error.response?.status) {
            case 404:
            case 401:
                dispatch(logout());
                history.navigate('/alliance/login');
                break;
            case 400:
                dispatch(dangerAlert({ message: errorMessage, showAfterRedirect: false }));
                break;
            default:
                dispatch(dangerAlert({ message: errorMessage || 'An unexpected error occurred', showAfterRedirect: false }));
                break;
        }
}

export const urlBuilder = (url: string, { customerId, startDate, endDate, searchTerm, page, sortDirection }: SearchTransactionDto) => {

    let newUrl = `${url}?id=${customerId}`;

    if (searchTerm) {
        newUrl += `&searchTerm=${searchTerm}`;
    } else {
        if (startDate)
            newUrl += `&startDate=${startDate.toLocaleDateString('en-US')}`;
        if (endDate)
            newUrl += `&endDate=${endDate.toLocaleDateString('en-US')}`;
    }

    if (page)
        newUrl += `&page=${page}`;
    if (sortDirection)
        newUrl += `&sortDirection=${sortDirection}`;
    return newUrl;
}

export const getAuthorizedApi = () => {
    return axios.create({
        baseURL: process.env.REACT_APP_BCDAPIURL,
        withCredentials: true,
        headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
            "Content-Type": "application/json",
            "Authorization": "Bearer " + getAccessToken()
        }
    });
};

export const hexToRgbA = (hex: string, opacity?: number) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const returnValue = result
        ? `rgba(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)},${opacity ? opacity : "1"})`
        : "";
    return returnValue;
}